import {useEffect, useState} from 'react'
import * as Security from '../api/archibus/SecurityApi'
import {getGuestUserAccount} from './authentication'
import {useUIState, useUIDispatch} from '../context/UIContext'

export const checkSession = ({isKiosk}) => {
  // Check if the user is authenticated
  let defaultProject = ''
  return Security.getProjects()
    .then(projects => {
      defaultProject = projects[0].id
      return Security.isOpenSession()
    })
    .then(isOpenSession => {
      if (isOpenSession) {
        return Promise.resolve({isSessionOpen: true})
      } else {
        // If Kiosk Login as GUEST
        if (isKiosk) {
          const {userName, password} = getGuestUserAccount()
          return Security.login(userName, password, defaultProject).then(() =>
            Promise.resolve({isSessionOpen: true})
          )
        } else {
          return Promise.resolve({isSessionOpen: false})
        }
      }
    })
}

export const useViewFetch = ({
  api,
  parameters = {},
  onChangeOf = [],
  initialState = [],
  onCallback = null
}) => {
  const [data, setData] = useState(initialState)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)
  const {isKiosk} = useUIState()
  const uiDispatch = useUIDispatch()

  useEffect(() => {
    let didCancel = false
    const fetchData = async () => {
      if (!didCancel) {
        setIsLoading(true)
        setError(null)

        try {
          const {isSessionOpen} = await checkSession({isKiosk})

          if (isSessionOpen) {
            const result = await api(parameters)
            if (!didCancel) {
              setData(result)
              if (onCallback) {
                onCallback(result)
              }
            }
          } else {
            // TODO: Dispatch logon form.
            uiDispatch({
              type: 'setContent',
              payload: {content: 'LOGON_CONTAINER'}
            })
          }
        } catch (error) {
          if (!didCancel) {
            setError(error)
          }
        }

        if (!didCancel) {
          setIsLoading(false)
        }
      }
    }

    fetchData()

    return () => {
      didCancel = true
    }
  }, onChangeOf)

  return {data, isLoading, error, onCallback}
}
